var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",staticClass:"go-back",attrs:{"href":_vm.href,"to":_vm.routerTo},on:{"click":_vm.goBack}},[_c('RButton',{attrs:{"type":"link"}},[_c('RIcon',{attrs:{"of":"ArrowLeft","stroke":"var(--cta)","height":"14","width":"16","vHeight":20,"vWidth":18,"minY":"2"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }